import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Home } from './main/pages/Home';
import { TopBar } from './main/components/TopBar';
import { Studies } from './main/pages/Studies';
import { Projects } from './main/pages/Projects';
import { Works } from './main/pages/Works';
import { ContactMe } from './main/pages/ContactMe';
import { AboutMe } from './main/pages/AboutMe';

export const AppRouter: React.FC = () => (
  <Router>
    <TopBar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/background" element={<Studies />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/works" element={<Works />} />
      <Route path="/contact-me" element={<ContactMe />} />
      <Route path="/about-me" element={<AboutMe />} />
    </Routes>
  </Router>
);
